import {Component, OnInit} from '@angular/core';
import {NodeBuilder} from '../../../../../../../shared/models';
import {CustomTransformNode, NODE_TYPE} from './customTransform';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import {newStepValue} from '../../../../../services/flowBuilder/utils/constants';
import {
    FunctionMetadata,
    WasabiFunctionsService
} from '../../../../../../../core/services/wasabi/wasabi-functions.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import { ClickatellExpansionPanelComponent } from '../../../../../../../shared/components/clickatell-expansion-panel/clickatell-expansion-panel.component';
import { MatExpansionPanelTitle } from '@angular/material/expansion';
import { ClickatellFormValidationComponent } from '../../../../../../../shared/components/clickatell-form-validation/clickatell-form-validation.component';
import { ActiveFormDirective } from '../../../../../../../shared/directives/active-form/active-form.directive';
import { MatSelect, MatOption } from '@angular/material/select';
import { LoadingIconComponent } from '../../../../../../../shared/components/loading-icon/loading-icon.component';
import { NgTemplateOutlet, AsyncPipe, KeyValuePipe } from '@angular/common';
import { CMSComponent } from '../../../../../../../shared/components/cms/cms.component';
import { NextSelectorComponent } from '../../../../json-to-from/next-selector/next-selector.component';

@Component({
    selector: 'app-custom-transform',
    templateUrl: './custom-transform.component.html',
    styleUrls: ['./custom-transform.component.scss'],
    imports: [ReactiveFormsModule, ClickatellExpansionPanelComponent, MatExpansionPanelTitle, ClickatellFormValidationComponent, ActiveFormDirective, MatSelect, MatOption, LoadingIconComponent, NgTemplateOutlet, CMSComponent, NextSelectorComponent, AsyncPipe, KeyValuePipe]
})
export class CustomTransformComponent extends NodeBuilder implements OnInit {

    public customTransformForm: UntypedFormGroup;
    public allFunctions: Observable<FunctionMetadata[]>;

    private functionMetadata: FunctionMetadata[];


    constructor(private wasabiFunctionsService: WasabiFunctionsService) {
        super(NODE_TYPE);
    }

    ngOnInit(): void {
        this.allFunctions = this.wasabiFunctionsService.getAllFunctions().pipe(
            map(allFunctions => {
                const functionMetadata = allFunctions.filter(wasabi => wasabi.active);
                this.functionMetadata = functionMetadata;
                return functionMetadata;
            })
        );
    }

    set buildForm(stepData: any) {

        this.customTransformForm = CustomTransformNode.toForm(stepData, this.canEdit);

        if (this.customTransformForm.get('success').value === newStepValue) {
            this.customTransformForm.get('success').setValue('step' + this.getNextStep());
        }
        if (this.customTransformForm.get('error').value === newStepValue) {
            this.customTransformForm.get('error').setValue('step' + this.getNextStep());
        }
    }

    get getStepData(): {} {
        const customTransformNode = new CustomTransformNode();
        customTransformNode.addNodeDetails(this.customTransformForm.getRawValue());
        return customTransformNode.nodeData;
    }

    get isNodeValid(): boolean {
        this.customTransformForm.markAllAsTouched();
        return this.customTransformForm.valid;
    }

    selectedFunction(functionId: string) {
        const functionMetadata = this.functionMetadata.find(value => value.id === functionId);
        let params = {};

        if (functionMetadata.params && functionMetadata.params.length > 0) {
            params = functionMetadata.params
                .map(value => ({[value.name]: ''}))
                .reduce((previousValue, currentValue) => ({...previousValue, ...currentValue}));
        }

        const formGroup = CustomTransformNode.buildParamForm(params, true);

        this.customTransformForm.setControl('params', formGroup);

    }

}
